<template>
  <page-view :title="false">
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form-model layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="出租状态">
                <a-select
                  v-model="queryParam.rentSta"
                  placeholder="请选择"
                  allowClear
                >
                  <a-select-option value="">全部</a-select-option>
                  <a-select-option value="0">未租</a-select-option>
                  <a-select-option value="1">已预订</a-select-option>
                  <a-select-option value="2">已出租</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-model-item label="小区">
                <a-input
                  allowClear
                  v-model="queryParam.communityName"
                  @change="onChange"
                  @click="onSearch"
                  placeholder="请选择小区"
                />
              </a-form-model-item>
            </a-col>

            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="楼号"
                  ><a-input v-model="queryParam.buildingNo" placeholder="楼号"
                /></a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="单元号"
                  ><a-input v-model="queryParam.unitNo" placeholder="单元号"
                /></a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="门牌号"
                  ><a-input v-model="queryParam.houseNum" placeholder="门牌号"
                /></a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="房号"
                  ><a-input v-model="queryParam.roomNum" placeholder="房号"
                /></a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="房源状态">
                  <a-select
                    v-model="queryParam.sta"
                    placeholder="请选择"
                    allowClear
                  >
                    <a-select-option value="I">有效房源</a-select-option>
                    <a-select-option value="X">无效房源</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="(!advanced && 8) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="
                  (advanced && { float: 'right', overflow: 'hidden' }) || {}
                "
              >
                <a-button type="primary" @click="$refs.table.refresh(true)"
                  >查询</a-button
                >
                <a-button style="margin-left: 8px" @click="reset"
                  >重置</a-button
                >
                <a-button
                  type="primary"
                  icon="plus"
                  style="margin-left: 8px"
                  @click="addNew"
                  >添加房源</a-button
                >
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? "收起" : "展开" }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form-model>
      </div>

      <!-- 数据表格 -->
      <s-table
        ref="table"
        size="default"
        :rowKey="getTableKey"
        :columns="columns"
        :data="loadData"
        :pageNum="queryParam.pageNum"
        showPagination="auto"
      >
        <span slot="titleItem" slot-scope="text, record">
          <template>
            <span>
              {{
                record.type == "group"
                  ? record.communityName +
                    "-" +
                    record.buildingNo +
                    "(号楼)-" +
                    record.unitNo +
                    "(单元)-" +
                    record.houseNum
                  : record.houseName
              }}
            </span>
          </template>
        </span>

        <span slot="tagItem" slot-scope="text, record">
          <template>
            {{ text }}
            <a-tag
              class="render-tag"
              color="#87d068"
              v-if="record.rentSta == '2'"
              >已出租</a-tag
            >
            <a-tag class="render-tag" color="#d03c16" v-if="record.sta == 'X'"
              >无效房源</a-tag
            >
          </template>
        </span>

        <span slot="action" slot-scope="text, record">
          <template>
            <div v-if="record.type == 'group'">
              <a class="a-action" @click="openModal(record)">分配管家</a>
              <a class="a-action" @click="openOwnerModal(record)">关联业主</a>
            </div>
            <div v-else>
              <a-popconfirm
                v-if="record.rentSta == '2'"
                title="确认上架?"
                @confirm="upDownHouse(record, 'up')"
                okText="确认"
                cancelText="取消"
              >
                <a class="a-action">上架</a>
              </a-popconfirm>

              <a-popconfirm
                v-if="record.rentSta == '0'"
                title="确认下架?"
                @confirm="upDownHouse(record, 'down')"
                okText="确认"
                cancelText="取消"
              >
                <a class="a-action">下架</a>
              </a-popconfirm>
              <a class="a-action" @click="goModifyHouse(record)">编辑</a>
              <a class="a-action" @click="goHouseInfo(record)">详情</a>

              <a-popconfirm
                title="确认解除?"
                v-if="record.ownerName"
                @confirm="deleteOwner(record)"
                okText="确认"
                cancelText="取消"
                ><a class="a-action">解除业主</a></a-popconfirm
              >
              <a
                class="a-action"
                v-if="record.rentSta == '0'"
                @click="createContract(record)"
                >创建租约</a
              >
            </div>
          </template>
        </span>
      </s-table>
    </a-card>
    <!-- 分配管家 -->
    <a-modal title="分配管家" v-model="modalVisible" @ok="allot">
      <a-select
        placeholder="请选择管家"
        style="width: 100%;"
        v-model="allotKeeper.userNo"
      >
        <a-select-option
          v-for="item in keeperList"
          :value="item.userNo"
          :key="item.userNo"
          >{{ item.nickName }}-{{ item.mobile }}</a-select-option
        >
      </a-select>
    </a-modal>
    <!-- 小区选择 -->
    <community-modal ref="comModal" @sure="selectCommunity"></community-modal>

    <!-- 绑定房东 -->
    <a-modal
      v-model="bindModal.visible"
      :title="bindModal.title"
      :footer="null"
      :width="1000"
    >
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="手机号"
                ><a-input
                  v-model="bindModal.queryParam.mobile"
                  placeholder="手机号"
              /></a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-button type="primary" @click="searchUser">查询</a-button>
              <a-button
                class="button-margin-left"
                @click="() => (bindModal.queryParam = {})"
                >重置</a-button
              >
            </a-col>
          </a-row>
        </a-form>
        <!-- 数据表格 -->
        <s-table
          ref="bindBable"
          size="default"
          rowKey="id"
          :columns="bindModal.columns"
          :data="bindModal.loadData"
          :isAuto="false"
          showPagination="auto"
        >
          <span slot="nickname" slot-scope="text, record">
            <template>
              <img
                :src="record.imageUrl"
                class="user-head"
                v-if="record.imageUrl"
              />
              {{ text }}
            </template>
          </span>
          <span slot="authsta" slot-scope="text"
            ><a-badge
              :status="text | statusTypeFilter"
              :text="text | statusFilter"
          /></span>
          <span slot="usertype" slot-scope="text">
            <a-tag
              :color="text == '1' ? '' : text == '2' ? '#2db7f5' : '#f50'"
              >{{
                text == "1" ? "普通用户" : text == "2" ? "管家" : "商户"
              }}</a-tag
            >
          </span>
          <span slot="action" slot-scope="text, record">
            <template>
              <a-popconfirm
                title="确认绑定吗?"
                @confirm="bindOwnerAction(record)"
                okText="确认"
                cancelText="取消"
                ><a class="a-action">绑定</a></a-popconfirm
              >
            </template>
          </span>
        </s-table>
      </div>
    </a-modal>
  </page-view>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import { PageView } from "@/layouts";
import { STable } from "@/components";
import CommunityModal from "./stepForm/CommunityModal";
export default {
  name: "HouseList",
  components: {
    PageView,
    CommunityModal,
    STable
  },
  data() {
    return {
      // 高级搜索 展开/关闭
      advanced: false,
      userInfo: {},
      // 查询参数
      queryParam: {
        userType: "", //用户类型
        userNo: "", //用户id
        buildingNo: "",
        houseNum: "",
        unitNo: "",
        roomNum: "",
        rentSta: "",
        communityCode: "",
        communityName: "",
        merchantNo: "",
        pageNum: 1
      },
      // 表头
      columns: [
        {
          title: "房源标题",
          dataIndex: "title",
          scopedSlots: { customRender: "titleItem" }
        },
        {
          title: "房号",
          dataIndex: "roomNum",
          scopedSlots: { customRender: "tagItem" }
        },
        {
          title: "月租金(元/月)",
          dataIndex: "rent"
        },
        {
          title: "管家名称",
          dataIndex: "keeperName"
        },
        {
          title: "业主名称",
          dataIndex: "ownerName"
        },
        {
          title: "操作",
          dataIndex: "action",
          align: "left",
          scopedSlots: { customRender: "action" }
        }
      ],
      //加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        this.queryParam.pageNum = parameter.pageNum;
        return this.$http.roomBksApi
          .pageHouseInfoGroup(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.resultObject;
          });
      },
      // 显示modal
      modalVisible: false,
      comModalVisible: false,
      keeperList: [], //管家
      //分配管家参数
      allotKeeper: {
        houseNo: "",
        userNo: undefined
      },
      //分配房东
      bindModal: {
        visible: false,
        title: "关联业主",
        children: [],
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {},
        // 表头
        columns: [
          {
            title: "用户昵称",
            dataIndex: "nickName",
            scopedSlots: { customRender: "nickname" }
          },
          {
            title: "性别",
            dataIndex: "sex"
          },
          {
            title: "手机号",
            dataIndex: "mobile"
          },
          {
            title: "邮箱",
            dataIndex: "email"
          },
          {
            title: "认证状态",
            dataIndex: "authSta",
            scopedSlots: { customRender: "authsta" }
          },
          {
            title: "用户类型",
            dataIndex: "userType",
            scopedSlots: { customRender: "usertype" }
          },
          {
            title: "操作",
            dataIndex: "action",
            align: "left",
            scopedSlots: { customRender: "action" }
          }
        ],
        //加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          return this.$http.roomBksApi
            .pageUserBase(Object.assign(parameter, this.bindModal.queryParam))
            .then(res => {
              return res.resultObject;
            });
        }
      }
    };
  },
  created() {
    let query = this.$route.query;
    if (query.param) {
      this.queryParam = Object.assign({}, this.queryParam, query.param);
    }
    this.userInfo = this.$store.getters.userInfo;
    this.queryParam.userType = this.userInfo.userType;
    this.queryParam.userNo = this.userInfo.userNo;
    this.getKeeperList();
  },
  methods: {
    getTableKey() {
      let date = new Date();
      return date.getTime() + "_" + Math.random() * 100000;
    },
    async getKeeperList() {
      let param = {};
      param.merchantNo = this.userInfo.merchantNo;
      this.$http.roomBksApi.findKeeperHelpDto(param).then(res => {
        if (res.result == 0) {
          this.keeperList = res.resultObject;
        }
      });
    },
    reset() {
      this.queryParam.buildingNo = "";
      this.queryParam.houseNum = "";
      this.queryParam.unitNo = "";
      this.queryParam.roomNum = "";
      this.queryParam.rentSta = "";
      this.queryParam.communityCode = "";
      this.queryParam.communityName = "";
      this.queryParam.merchantNo = "";
      this.queryParam.pageNum = 1;
    },
    onChange(evt) {
      this.queryParam.communityCode = "";
      this.queryParam.communityName = "";
    },
    onSearch() {
      this.$refs.comModal.show();
    },
    selectCommunity(item) {
      Object.assign(this.queryParam, item);
    },
    toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    addNew() {
      this.$router.push({
        name: "AddHouse",
        query: { param: this.queryParam }
      });
    },
    createContract(info) {
      this.$router.push({
        name: "CreateLeaseInfo",
        query: {
          houseNo: info.houseNo,
          keeperNo: info.keeperNo,
          payWay: info.payWay,
          param: this.queryParam
        }
      });
    },
    goHouseInfo(info) {
      this.$router.push({
        name: "HouseInfo",
        query: {
          houseNo: info.houseNo,
          keeperNo: info.keeperNo,
          param: this.queryParam
        }
      });
    },
    goModifyHouse(info) {
      this.$router.push({
        name: "ModifyHouse",
        query: {
          houseNo: info.houseNo,
          keeperNo: info.keeperNo,
          param: this.queryParam,
          type: "list"
        }
      });
    },
    openOwnerModal(item) {
      this.bindModal.children = [];
      this.bindModal.children = item.children;
      this.bindModal.visible = true;
    },
    bindOwnerAction(item) {
      let houseList = this.bindModal.children;
      let no = "";
      for (let house of houseList) {
        no += house.houseNo + ",";
      }
      //nickName
      let param = {};
      param.userNo = item.userNo;
      param.houseNo = no;
      this.$http.roomBksApi.saveHouseOwner(param).then(res => {
        if (res.result == 0) {
          this.$message.success(res.msg);
          this.bindModal.visible = false;
        }
      });
    },
    deleteOwner(item) {
      //解除房东
      this.$http.roomBksApi
        .deleteHouseOwner({ houseNo: item.houseNo })
        .then(res => {
          if (res.result == 0) {
            item.ownerName = "";
            this.$message.success(res.msg);
          }
        });
    },
    searchUser() {
      if (!this.bindModal.queryParam.mobile) {
        this.$message.info("请输入手机号");
        return;
      }
      this.$refs.bindBable.refresh(true);
    },
    openModal(item) {
      let houseList = item.children;
      let no = "";
      for (let house of houseList) {
        no += house.houseNo + ",";
      }
      this.allotKeeper.houseNo =
        no.length > 0 ? no.substring(0, no.length - 1) : "";
      this.modalVisible = !this.modalVisible;
    },
    //分配管家
    allot() {
      this.$http.roomBksApi.saveHouseKeeper(this.allotKeeper).then(res => {
        this.modalVisible = false;
        if (res.result == 0) {
          this.$message.success(res.msg);
          this.$refs.table.refresh(true);
        }
      });
    },
    //上/下架
    upDownHouse(item, type) {
      const param = {};
      param.type = type;
      param.houseNo = item.houseNo;
      this.$http.roomBksApi.saveUpDownHouseInfo(param).then(res => {
        if (res.result == 0) {
          this.$refs.table.refresh(true);
          this.$message.success(res.msg);
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.user-head {
  width: 40px;
  height: 40px;
  margin-right: 5px;
}
</style>
